import { EventWithSubEvents } from "@lib/types/EventWithSubEvents"
import { Box, Checkbox } from "@mui/material"
import { TreeItem } from "@mui/x-tree-view/TreeItem"
import { FC } from "react"
import AdminEventLink from "./AdminEventLink"

interface EventTreeItemProps {
    event: EventWithSubEvents
    selectedEventIds?: string[]
    onSelectionChange?: (eventId: string) => void
}

const EventTreeItem: FC<EventTreeItemProps> = ({ event, selectedEventIds, onSelectionChange }) => {
    const isSelected = selectedEventIds?.includes(event.event.id) ?? false;

    return (
        <TreeItem
            itemId={event.event.id}
            label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {onSelectionChange && (
                        <Checkbox
                            size="small"
                            checked={isSelected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => onSelectionChange(event.event.id)}
                            sx={{ p: 0, mr: 0.5 }}
                        />
                    )}
                    <AdminEventLink event={event.event} />
                </Box>
            }
        >
            {event.subEvents.map(x => (
                <EventTreeItem
                    key={x.event.id}
                    event={x}
                    selectedEventIds={selectedEventIds}
                    onSelectionChange={onSelectionChange}
                />
            ))}
        </TreeItem>
    )
}

export default EventTreeItem;
